import { Button, Heading, useToast } from '@chakra-ui/react';
import React, { FC } from 'react';
import { AiOutlineLeft } from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import NotificationForm from '../../components/notifications/NotificationForm';
import { CreateNotificationMutationVariables, useCreateNotificationMutation } from '../../graphql/notifications/generated/createNotification.generated';

const CreateNotification: FC = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [createNotification, { loading }] = useCreateNotificationMutation();

  const onSubmit = async (data: CreateNotificationMutationVariables) => {
    try {
      await createNotification({
        variables: data,
      });
      toast({
        title: 'Benachrichtigung wurde gesendet',
        description: 'Benachrichtigung wurde gesendet, der Status kann in der Übersicht überprüft werden.',
        status: 'success',
        isClosable: true,
        duration: 5000,
      });
      navigate('/notifications');
    } catch (e) {
      if (e instanceof Error) {
        toast({
          title: 'Es ist etwas schiefgelaufen',
          description: `Fehlermeldung: ${e.message}`,
          status: 'error',
          isClosable: true,
          duration: 5000,
        });
      }
    }
  };

  return (
    <Layout>
      <Heading>Benachrichtigung senden</Heading>
      <Button
        as={Link}
        to="/notifications"
        mt="4"
        leftIcon={<AiOutlineLeft />}
      >
        Zurück
      </Button>
      <NotificationForm
        loading={loading}
        onSubmit={onSubmit}
      />
    </Layout>
  );
};

export default CreateNotification;
